module.exports = __webpack_public_path__ + "img/img3.bb3f6a47.png";